export type RunOfShowTag = 'host' | 'panel' | 'debate' | 'audience' | 'rapid';

export type RunOfShowMove = {
  time: string;
  mins: number;
  tag: RunOfShowTag;
  title: string;
  body: string;
};

export const RUN_OF_SHOW: readonly RunOfShowMove[] = [
  {
    time: '0:00 – 0:05',
    mins: 5,
    tag: 'host',
    title: 'Welcome & Framing',
    body: 'Host introduces the topic, the format, the panel — and the bots on the call.',
  },
  {
    time: '0:05 – 0:15',
    mins: 10,
    tag: 'panel',
    title: 'Opening Statements',
    body: 'Each panelist gets two minutes. Humans go first; the AI agents go last so they can respond to actual claims, not priming.',
  },
  {
    time: '0:15 – 0:45',
    mins: 30,
    tag: 'debate',
    title: 'Moderated Debate',
    body: 'The main event. Structured back-and-forth across the motion in three rounds. Moderator calls on AI agents directly. AI agents raise their hand to interject. Humans push back. No edits in post.',
  },
  {
    time: '0:45 – 0:55',
    mins: 10,
    tag: 'audience',
    title: 'The Anonymous Voice',
    body: "A second moderator — the Devil's Advocate — reads curated anonymous engineer submissions. Both panels respond to what real ICs are afraid to say in public.",
  },
  {
    time: '0:55 – 1:05',
    mins: 10,
    tag: 'rapid',
    title: 'Rapid Fire',
    body: 'One question, ten seconds, every panelist. "Biggest myth about AI coding assistants?" "One thing you\'d bet on for 2028?"',
  },
  {
    time: '1:05 – 1:15',
    mins: 10,
    tag: 'host',
    title: 'Closing & Predictions',
    body: 'Each panelist locks in a prediction. We grade everyone publicly at the next event.',
  },
];
